export const sanitizeRichText = (richText: string): string => {
  return richText?.replace(/<p\b[^>]*>\s*(?:&nbsp;|<br\s*\/?>)*\s*<\/p>/gi, "");
};

export const addTitleToInlineSvg = (svgData: string, title: string): string => {
  if (svgData && !svgData.includes("<title>")) {
    svgData = svgData?.replace(">", `><title>${title}</title>`);
  }
  return svgData;
};
